import axios from 'axios';
import config from 'core/config';
import { FAQCategory } from 'core/models';
import { ApiClient } from '../apiClient';
import { ApiError } from '../errors';

export class FAQApi extends ApiClient {
  async list(): Promise<FAQCategory[]> {
    try {
      const response = await axios.get<FAQCategory[]>(config.faqJsonFileUrl);
      return response.data;
    } catch (e) {
      if (axios.isAxiosError(e)) {
        throw new ApiError(e.response?.status);
      }
      throw e;
    }
  }
}
